import React from "react";
import { globalFileServer } from '../../../axiosInstance';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ProductAddToCart from "../routs/productPage/ProductAddToCart";
import ProductInfo from "../productInfo/ProductInfo";
import { CollectSiteProductRemoveProduct } from "../../server/CollectSite";
import { setToggleCart } from "../../server/CartsOpen";
import { showAlertWithConfirm } from "../../server/ShowAlert";

const MiniCart = ({ setProductPopUp, setSelectedProd }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { productsInCart, productSale, user, role, deliveryPrice } = useSelector(state => ({
    productsInCart: state.productsInCart.productsInCart,
    productSale: state.productsInCart.productSale,
    user: state.user.user,
    role: state.user.role,
    deliveryPrice: state.productsInCart.deliveryPrice,
  }));
  
  // Calculate total items count
  const totalItems = productsInCart.reduce((total, item) => total + item.Quantity, 0);
  
  // Calculate total price
  const subtotal = productsInCart.reduce((total, item) => {
    return total + (item.Price * item.Quantity);
  }, 0);
  
  // Calculate sale total if applicable
  const saleTotal = productSale.reduce((total, item) => {
    return total + (item.Price * item.QuantiyUse);
  }, 0);
  
  // Final total including delivery
  const totalPrice = subtotal - saleTotal + deliveryPrice;

  const goToCart = () => {
    dispatch(setToggleCart(false)); // סגירת הסיידבר אם קיים
    const unavailableItems = productsInCart.filter(product => product.Quantity == 0);
    if (unavailableItems.length > 0) {
      const itemNames = unavailableItems.map(item => item.ProductName).join('<br>');
      showAlertWithConfirm({
        msgHtml: `<div class="missing-items-alert">שים לב: הפריטים הבאים אזלו מהמלאי:<div class="missing-items-container"><strong>${itemNames}</strong></div></div>`,
      });
    }
    navigate("/cart");
  };

  let saleItem;
  
  return (
    <div className="header-cart">
      <div className="header-cart-wrap">
        <div className="products">
          <table>
            <tbody>
              {productsInCart.length ? productsInCart.map(element => {
                saleItem = productSale.find(item => item.CollectSiteProductId == element.Id);
                return (
                  <tr className="item-mini-cart" key={element.Id} onClick={() => { setProductPopUp(true); setSelectedProd(element); }}>
                    <td className="prod-info-and-name">
                      <div className="delete-item">
                        <button onClick={(e) => { e.stopPropagation(); dispatch(CollectSiteProductRemoveProduct(element, -1)) }} className="delete-btn">
                          <span className="delete-icon">✖</span>
                        </button>
                      </div>
                      <ProductInfo selectedProd={element} />
                      {saleItem?.Text ? <p className="sale">במבצע!</p> : null}
                      {element.CommentWarning && <p className="comment-warning">{element.CommentWarning}</p>}
                    </td>
                    <td className="price-details">
                      <p className="price">{(element.Price * element.Quantity).toFixed(2)} <span>₪</span></p>
                      {saleItem?.Price ? 
                        <p className="sale">
                          {(saleItem.Price * saleItem.QuantiyUse).toFixed(2)} <span>- ₪</span>
                        </p> : null}
                      <div className="quantity" onClick={(e)=> {e.stopPropagation();}}>
                      <ProductAddToCart element={element} haveInfo={false} />
                      </div>
                    </td>
                  </tr>
                );
              }) : null}
              <tr className="delivery-price">
                <td><p>מחיר משלוח:</p></td>
                <td><p className="price">{deliveryPrice} <span>₪</span></p></td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <div className="cart-summary">
          <div className="summary-row">
            <span>סה"כ מוצרים:</span>
            <span>{totalItems}</span>
          </div>
          <div className="summary-row">
            <span>סה"כ:</span>
            <span>{subtotal.toFixed(2)} ₪</span>
          </div>
          {saleTotal > 0 && (
            <div className="summary-row">
              <span>הנחה:</span>
              <span>- {saleTotal.toFixed(2)} ₪</span>
            </div>
          )}
          <div className="summary-row">
            <span>משלוח:</span>
            <span>{deliveryPrice} ₪</span>
          </div>
          <div className="summary-row total">
            <span>סה"כ לתשלום:</span>
            <span>{totalPrice.toFixed(2)} ₪</span>
          </div>

          <button className="checkout-btn" onClick={goToCart}>לתשלום</button>
        </div>
      </div>
    </div>
  );
};

export default MiniCart;